import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Whiteboard as ClsWhiteboard } from '@classity-edtech/ui-base/dist/components/Displays/Whiteboard/Whiteboard';
import Helmet from '../../components/Helmet';

export interface HomeProps extends MuiBoxProps {}

export const Whiteboard = ({ className }: HomeProps) => {
  return (
    <>
      <Helmet />
      <ClsWhiteboard
        showClearOption={false}
        showLoadOption={false}
        sx={{
          height: '100dvh',
          width: '100%',
        }}
      />
    </>
  );
};

Whiteboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Whiteboard.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(Whiteboard)(
  ({ theme }) => `
`,
);
